import { type SelectFieldProps, SelectField, useGetList } from "react-admin";

import { MODULE_NAMES } from "@/constants/modules";

import { type LandingRecord } from "./types";

export const LandingField = (props: SelectFieldProps) => {
  const { isPending, isLoading, data } = useGetList<LandingRecord>(
    MODULE_NAMES.LANDINGS,
  );

  const choices = (data ?? []).map((choice) => ({
    id: `/api/vpn/landings/${choice.id}`,
    name: choice.title,
  }));

  return (
    <SelectField
      {...props}
      isPending={isPending}
      isLoading={isLoading}
      choices={choices}
    />
  );
};
